/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OIDCUserPreferences,
  OIDCUserPreferencesError,
  OIDCUserPreferencesRequest,
  PatchedOIDCUserPreferencesRequest,
} from '../models';
import {
    OIDCUserPreferencesFromJSON,
    OIDCUserPreferencesToJSON,
    OIDCUserPreferencesErrorFromJSON,
    OIDCUserPreferencesErrorToJSON,
    OIDCUserPreferencesRequestFromJSON,
    OIDCUserPreferencesRequestToJSON,
    PatchedOIDCUserPreferencesRequestFromJSON,
    PatchedOIDCUserPreferencesRequestToJSON,
} from '../models';

export interface UserPreferencesPartialUpdateRequest {
    patchedOIDCUserPreferencesRequest?: PatchedOIDCUserPreferencesRequest;
}

export interface UserPreferencesUpdateRequest {
    oIDCUserPreferencesRequest?: OIDCUserPreferencesRequest;
}

/**
 * 
 */
export class UserPreferencesApi extends runtime.BaseAPI {

    /**
     */
    async userPreferencesPartialUpdateRaw(requestParameters: UserPreferencesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OIDCUserPreferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/user-preferences/`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedOIDCUserPreferencesRequestToJSON(requestParameters.patchedOIDCUserPreferencesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OIDCUserPreferencesFromJSON(jsonValue));
    }

    /**
     */
    async userPreferencesPartialUpdate(requestParameters: UserPreferencesPartialUpdateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OIDCUserPreferences> {
        const response = await this.userPreferencesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userPreferencesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OIDCUserPreferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/user-preferences/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OIDCUserPreferencesFromJSON(jsonValue));
    }

    /**
     */
    async userPreferencesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OIDCUserPreferences> {
        const response = await this.userPreferencesRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userPreferencesUpdateRaw(requestParameters: UserPreferencesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OIDCUserPreferences>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/user-preferences/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OIDCUserPreferencesRequestToJSON(requestParameters.oIDCUserPreferencesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OIDCUserPreferencesFromJSON(jsonValue));
    }

    /**
     */
    async userPreferencesUpdate(requestParameters: UserPreferencesUpdateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OIDCUserPreferences> {
        const response = await this.userPreferencesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
